import React, { useState, useEffect, useRef } from "react";

import { Canvas, Group, useThree, useFrame } from "react-three-fiber";
import {
  OrbitControls,
  Stage,
  Environment,
  Sky,
  CameraControls,
  axesHelper,
  Grid,
} from "@react-three/drei";

import Face from "../3d/Face";
import Footer from "../3d/Footer";
import Central from "../3d/Central";
import CAPRIATA from "../3d/CAPRIATA";

export default function Viewer3d(props) {
  const { final } = props;
  const cameraRef = useRef();
  const footerRef = useRef(null);
  const [cPosition, setCPosition] = useState(false);
  useEffect(() => {
    console.log(cPosition);
  }, [cPosition]);
  function Frame() {
    useFrame((state) => {
      if (cPosition) {
        state.camera.position.lerp(
          {
            x: cPosition?.x,
            y: cPosition?.y,
            z: cPosition?.z || 15,
          },
          0.03
        );
      }
    });
  }

  return (
    <Canvas
      camera={{ fov: 60, position: [-30, 0, 0] }}
      style={{ backgroundColor: "#fff", height: "650px" }}
    >
      <Frame></Frame>
      <axesHelper args={[5]} />

      <OrbitControls
        refs={cameraRef}
        target={[25, 25, 25]}
        minZoom={0}
        maxZoom={0}
        minDistance={25}
        maxDistance={200}
        makeDefault
        enablePan={false}
        //enableZoom={false}
        target0={[25, 25, 25]}
        onStart={() => setCPosition(false)}
      />
      <Environment
        // path="https://cdn.jsdelivr.net/gh/mrdoob/three.js@r123/examples/textures/cube/MilkyWay/"
        // files={[
        //   "dark-s_px.jpg",
        //   "dark-s_nx.jpg",
        //   "dark-s_py.jpg",
        //   "dark-s_ny.jpg",
        //   "dark-s_pz.jpg",
        //   "dark-s_nz.jpg",
        // ]}
        preset="warehouse"
        blur={0.6}
        background
      />

      {final.items && (
        <Stage
        //preset="portrait"
        //intensity={1}
        //environment="apartment"
        //shadows="accumulative"
        >
          <ambientLight intensity={3.5} />
          <pointLight position={[10, 10, 10]} />
          {<Face final={final} update={setCPosition} />}

          {<Central update={setCPosition} final={final} />}

          {final.items && (
            <Footer
              final={final}
              update={setCPosition}
              position={[18 + 6 * (final.items / 2 - 1), 0, -18]}
              rotation={[0, Math.PI, 0]}
            />
          )}
        </Stage>
      )}
    </Canvas>
  );
}
